var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":"Counter","item-text":"id","item-value":"id","items":_vm.countersLight},model:{value:(_vm.selectedCounter),callback:function ($$v) {_vm.selectedCounter=$$v},expression:"selectedCounter"}})}
var staticRenderFns = []

export { render, staticRenderFns }